import { Button, DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelSurchargeOptionsSlideout extends Layout {
    buttonAddCustomFuelSurchargeTable: Button;
    panel1: Panel;
    panel4: Panel;
    panel5: Panel;
    panelFormula: Panel;
    sourceCustomerFuelOptions: DataSource;
    switchCredit: Switch;
    textboxAmount: Textbox;
    textboxApplyDoeRate: Textbox;
    textboxBasePrice: Textbox;
    textboxCustomCalc: Textbox;
    textboxCustomFscHdrId: Textbox;
    textboxCustomFscIndexId: Textbox;
    textboxCustomFscRegionId: Textbox;
    textboxDateOpt: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDelayDays: Textbox;
    textboxDescr: Textbox;
    textboxFscCycleCode: Textbox;
    textboxFuelPercent: Textbox;
    textboxFuelSurchargeId: Textbox;
    textboxFuelSurchargePayId: Textbox;
    textboxFuelVariance: Textbox;
    textboxMethod: Textbox;
    textboxOrderTypeId: Textbox;
    textboxRegion: Textbox;
    textboxRoundSurchgCalc: Textbox;
    textboxSurchgEnddt: Textbox;
    textboxSurchgStrtdt: Textbox;
    textboxTruckloadLtl: Textbox;
}
